import { Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export default function initCatalog() {
  function initSliders() {
    const sizeSlider = document.querySelector('#sizes-strip-wrap .size-strip-swiper') as HTMLElement;
    if (sizeSlider) {
      /* eslint-disable no-new */
      new Swiper(sizeSlider, {
        modules: [Navigation],
        slidesPerView: 'auto',
        navigation: {
          nextEl: '#sizes-strip-wrap .size-strip-swiper-button-next',
          prevEl: '#sizes-strip-wrap .size-strip-swiper-button-prev',
          disabledClass: 'hidden',
        },
        spaceBetween: 8,
        on: {
          init: () => {
            document.querySelector('#refinements-wrap')?.classList.remove('hidden');
          },
        },
      });
    }
    const categorySlider = document.querySelector('#category-strip-wrap .category-strip-swiper') as HTMLElement;
    if (categorySlider) {
      /* eslint-disable no-new */
      new Swiper(categorySlider, {
        modules: [Navigation],
        slidesPerView: 'auto',
        navigation: {
          nextEl: '#category-strip-wrap .category-strip-swiper-button-next',
          prevEl: '#category-strip-wrap .category-strip-swiper-button-prev',
          disabledClass: 'hidden',
        },
        spaceBetween: 11,
        on: {
          init: () => {
            document.querySelector('#category-strip-wrap')?.classList.remove('hidden');
          },
        },
      });
    }
  }

  initSliders();
}

export function initColorSlider(id: string) {
  const swiperEl = document.getElementById(id)?.querySelector('.product-color-swiper') as HTMLElement;
  if (swiperEl) {
    /* eslint-disable no-new */
    new Swiper(swiperEl, {
      modules: [Navigation],
      loop: true,
      spaceBetween: 11,
      slidesPerView: 'auto',
      navigation: {
        nextEl: `#${id} .product-card-color-swiper-button-next`,
        prevEl: `#${id} .product-card-color-swiper-button-prev`,
      },
    });
  }
}
